import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

const LoadMoreButton = ({ onClick, loading }) => {
  return (
    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
      <Button
        variant="outlined"
        onClick={onClick}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : "Load More"}
      </Button>
    </Box>
  );
};

export default LoadMoreButton; 